import React from 'react';
import { GoogleOutlined } from '@ant-design/icons';
import 'firebase/app';

import { auth } from '../firebase';
import firebase from 'firebase/app';

const Login = () => {
    return ( 
        <div className="" id="login-page">
            <div className="" id="login-card">
                <h2>FRENDZ CHAT APP</h2>

                <div className="login-button google"
                onClick = {() => auth.signInWithRedirect(new firebase.auth.GoogleAuthProvider())}>
                    <GoogleOutlined /> Sign In with Google
                </div>
            </div>
        </div>
     );
}
 
export default Login;